export default __webpack_public_path__ + "static/media/ADD.ce806465.svg";